import PlaceIcon from '~/icons/iconography/place.svg';
import { useFrame } from '~/services/umbraco/hooks';
import { IconLabel, IconLinkButton } from '../styled';

export const FindStore = () => {
    const { data: storesPage } = useFrame((frame) => frame?.staticLinks?.storesPage);

    if (!storesPage) {
        return null;
    }

    return (
        <IconLinkButton href={storesPage.url}>
            <PlaceIcon />
            <IconLabel>{storesPage.text}</IconLabel>
        </IconLinkButton>
    );
};
